import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

// components
// import Arrow from 'components/Other/Arrow';

// styles
import style from './index.module.scss';

// packages
import gsap, { ScrollTrigger, Power3 } from 'gsap/all';

import startGsapAnimation from '../../../helpers/gsapMethods/startGsapAnimation';
import killScrollTrigger from '../../../helpers/gsapMethods/killScrollTrigger';
import generateId from '../../../helpers/generateId';

const Philosophy = () => {
  // register plug in for gsap
  gsap.registerPlugin(ScrollTrigger);

  // dom refs
  const containerRef = useRef(null),
    titleRef = useRef(null),
    textRef = useRef(null),
    ctaRef = useRef(null),
    titleLinesRef = useRef(null),
    ourPhilosophyRef = useRef(null);

  // timeline, null before init
  let tl = null;

  // animation
  const animate = (scrollTriggerId) => {
    tl = gsap.timeline({
      defaults: { duration: 1, ease: Power3.ease },
      scrollTrigger: {
        id: scrollTriggerId,
        trigger: textRef.current,
        // start: "top center",
        start: 'top bottom',
        end: 'top 50%',
        // markers: true,
        scrub: 3,
        once: true
        // onUpdate: (self) => {
        //   console.log(
        //     `progress ${scrollTriggerId}:, progress: ${self.progress}, start: ${
        //       self.start
        //     }, "velocity:", ${self.getVelocity()}`
        //   );
        // }
      }
    });

    tl.to(ourPhilosophyRef.current, { autoAlpha: 1, y: 0 });
    tl.to(titleLinesRef.current.children, { autoAlpha: 1, y: 0, stagger: 0.25 }, '-=0.75');
    tl.to(textRef.current.children, { autoAlpha: 1, y: 0 }, '-=0.5');
  };

  useEffect(() => {
    setTimeout(() => {
      const scrollTriggerId = generateId();
      // console.log(`HOME > PHILOSOPHY ID: ${scrollTriggerId}`);
      startGsapAnimation(scrollTriggerId, animate);
      return killScrollTrigger(scrollTriggerId, ScrollTrigger, tl);
    }, 750);
  }, []);

  return (
    <div className={style.section} ref={containerRef}>
      <div className={style.container}>
        <div className={style.left}>
          <div className={style['title-container']} ref={titleRef}>
            <div className={style.title} ref={ourPhilosophyRef}>
              Our philosophy
            </div>
            <div className={style.title} ref={titleLinesRef}>
              <div className={style['title-line']}>We love ad tech.</div>
              <div className={style['title-line']}>We’re experts in it.</div>
              <div className={style['title-line']}>However, thinking</div>
              <div className={style['title-line']}>matters more.</div>
            </div>
          </div>
        </div>
        <div className={style.right}>
          <div className={style['text-container']} ref={textRef}>
            <div className={style.text}>
              Simply adding more ad tech is not the answer...
              <br /> We solve the challenges of personalization for brands
              <br />
              and creative teams by devising creative learning
              <br />
              agendas that work hand in hand with their media
              <br />
              goals, content strategy and chosen ad tech partners.
            </div>
            <div className={style['cta-container']} ref={ctaRef}>
              <Link className={style.ctaLink} to="/how-it-works">
                <div className={style.cta}>Find out how it works</div>
              </Link>
            </div>
          </div>
        </div>
        {/* <Arrow colour="#063a53" direction="down" className={style.arrow} /> */}
      </div>
    </div>
  );
};

export default Philosophy;
